interface AgendaCommentData {
  id?: number;
  agendaId?: number;
  weekfirstday?: string;
  comment?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
}

export class AgendaComment {
  public static getNonTranslatableFields(): string[] { return ['id', 'agendaId', 'weekfirstday', 'comment', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'agendaId', 'weekfirstday', 'comment', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getKeyFields(): string[] { return ['id']; }


  id?: number;
  agendaId?: number;
  weekfirstday?: string;
  comment?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;


  public static fromAPI(data: any): AgendaComment {
    return new AgendaComment({
      id: parseFloat(data['id']),
      agendaId: parseFloat(data['agendaId']),
      weekfirstday: data['weekfirstday'],
      comment: data['comment'],
      createDate: data['createDate'],
      createrId: parseFloat(data['createrId']),
      updateDate: data['updateDate'],
      updaterId: parseFloat(data['updaterId'])
    })
  }
  public static fromAPIList(data: AgendaCommentData[]): AgendaComment[] {
    return data.map((item) => AgendaComment.fromAPI(item));
  }

  constructor({ id, agendaId, weekfirstday, comment, createDate, createrId, updateDate, updaterId }: AgendaCommentData) {
    this.id = id;
    this.agendaId = agendaId;
    this.weekfirstday = weekfirstday;
    this.comment = comment;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
  }

  public toJson(): AgendaCommentData {
    return {
      id: this.id,
      agendaId: this.agendaId,
      weekfirstday: this.weekfirstday,
      comment: this.comment,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId
    }
  }
}
